module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-notification pm-notification"
  }, [_c('div', {
    staticClass: "notification",
    class: {
      success: (_vm.notification.style === 'success'), alert: (_vm.notification.style === 'alert'), warning: (_vm.notification.style === 'warning')
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Close alert",
      "type": "button"
    },
    on: {
      "click": _vm.removeNotification
    }
  }, [_c('span', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('small', [_vm._v(_vm._s(_vm.notification.code))]), _c('h4', [_c('strong', [_vm._v(_vm._s(_vm.notification.title))])]), (Array.isArray(_vm.notification.subtitle)) ? _vm._l((_vm.notification.subtitle), function(subtitle) {
    return _c('div', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(subtitle))])
  }) : [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.notification.subtitle))])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e1b6f4c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Notification.vue
// module id = 2322
// module chunks = 1